import type { ReactNode, RefObject } from 'react'
import { memo } from 'react'

import { ScrollArea } from '@/components/ui/scroll-area'

import type { Notification, NotificationClickHandler } from './notification.interface'
import { NotificationItem } from './notification-item.atom'

export interface NotificationListProps {
  notificationList: Notification[]
  onNotificationClick: NotificationClickHandler
  itemRefs: RefObject<(HTMLDivElement | null)[]>
}

const NotificationListBase: React.FC<NotificationListProps> = ({
  notificationList,
  onNotificationClick,
  itemRefs,
}): ReactNode => {
  return (
    <ScrollArea className="notification-list h-[400px]">
      <div className="p-2 space-y-1">
        {notificationList.map((notification, index) => (
          <div
            key={notification.id}
            ref={(el) => {
              if (itemRefs.current) {
                itemRefs.current[index] = el
              }
            }}
            tabIndex={-1}
          >
            <NotificationItem notification={notification} onClick={onNotificationClick} />
          </div>
        ))}
      </div>
    </ScrollArea>
  )
}

export const NotificationList = memo(NotificationListBase)

NotificationList.displayName = 'NotificationList'
